import { ReactComponent as DeleteIcon } from '@/assets/trash_bin.svg'
import PermissionsController from '@/components/PermissionsController'
import { DATE_TIME_FORMAT } from '@/libs/core/constants'
import durationToStr from '@/libs/utils/durationToStr'
import MenuIcon from '@mui/icons-material/MenuOutlined'
import PostAddOutlined from '@mui/icons-material/PostAddOutlined'
import Preview from '@mui/icons-material/Preview'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const VideoItem = ({
  name,
  avgCourseRating,
  courseLength,
  courseLabelList = [],
  coverImage,
  lastModifiedTime,
  onPreviewClick,
  onDelete,
  onEditCoursePrograms,
  onReorderHover,
  onReorderHoverExit,
  onVideoPreviewClick,
}) => {
  const { t } = useTranslation()

  return (
    <Stack flexDirection={'row'} alignItems="center" height={120} mt={3}>
      <Stack width={80} alignItems="center">
        <MenuIcon
          onMouseEnter={() => onReorderHover?.()}
          onMouseLeave={() => onReorderHoverExit?.()}
          sx={{ cursor: 'grab' }}
        />
      </Stack>
      <img
        style={{ maxHeight: '100%', cursor: 'pointer' }}
        src={coverImage}
        onClick={() => {
          onVideoPreviewClick()
        }}
      />
      <Stack flex={1} height="100%" p={1} gap={1}>
        <Stack
          alignItems={'center'}
          flexDirection={'row'}
          color={theme => theme.palette.secondary_80.main}
        >
          <Typography>{name}</Typography>
          <ThumbUpAltIcon sx={{ color: '#F60' }} ml={1} />
          <Typography display="flex" justifyContent="center" variant="body2" mr={1}>
            {avgCourseRating || '-'}
          </Typography>
          <Typography variant="caption" color={theme => theme.palette.grey_60.main}>
            {durationToStr(courseLength)}
          </Typography>
        </Stack>
        <Stack flexDirection={'row'} gap={1}>
          {courseLabelList.slice(0, 5).map(({ name: labelName }, index) => (
            <Typography
              key={`course_label_${index + 1}`}
              color={theme => theme.palette.grey_60.main}
              borderRadius={1.5}
              border={theme => `1px solid ${theme.palette.grey_60.main}`}
              p={0.5}
            >
              {labelName}
            </Typography>
          ))}
          {courseLabelList.length > 5 && <Typography>...</Typography>}
        </Stack>
        <Stack flex={1} />
        <Typography color={theme => theme.palette.grey_60.main}>{`${t(
          'general.last_modified_time',
        )}: ${
          lastModifiedTime ? moment(lastModifiedTime).format(DATE_TIME_FORMAT) : '-'
        }`}</Typography>
      </Stack>
      <Stack flexDirection={'row'} gap={2}>
        <Tooltip title={t('tooltips.preview_video')} placement="bottom">
          <IconButton color={'secondary_80'} onClick={onPreviewClick}>
            <Preview />
          </IconButton>
        </Tooltip>

        <PermissionsController permission="courseVideosList_modify">
          <Tooltip title={t('tooltips.add_to_other_list')} placement="bottom">
            <IconButton color={'secondary_80'} onClick={onEditCoursePrograms}>
              <PostAddOutlined />
            </IconButton>
          </Tooltip>
        </PermissionsController>

        <PermissionsController permission="courseVideosList_delete">
          <Tooltip title={t('tooltips.remove_video')} placement="bottom">
            <IconButton color={'secondary_80'} onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </PermissionsController>
      </Stack>
    </Stack>
  )
}

export default VideoItem
